import React from "react";

const TabTitle = ({ activeTab }) => {
  const getTabTitle = (tab) => {
    switch (tab) {
      // Páginas principais
      case "LandingPage":
        return "Bem-Vindo";
      case "LoginPage":
        return "Login";
      case "RegisterPage":
        return "Registro - ACADE";

      // Páginas do Dashboard
      case "Home":
        return "Home";
      case "Cadastrar Aluno":
        return "Cadastrar Aluno";
      case "Pré-registos":
        return "Pré-registos";
      case "Lista de Alunos":
        return "Lista de Alunos";
      case "Cadastrar Professor":
        return "Cadastrar Professor(a)";
      case "Lista de Professores":
        return "Lista de Professores(as)";
      case "Usuários do Sistema":
        return "Usuários do Sistema";
      case "Finanças":
        return "Finanças";
      
      default:
        return "ACADE-Gestor Escolar";
    }
  };

  // Atualiza o título da aba do navegador quando a aba/página ativa muda
  React.useEffect(() => {
    document.title = getTabTitle(activeTab);
  }, [activeTab]);

  return null; // Este componente não precisa renderizar nada no DOM
};

export default TabTitle;
